import React from 'react';
import { GoogleLogin } from 'react-google-login-component'

class About extends React.Component {

  responseGoogle(googleUser) {
    var id_token = googleUser.getAuthResponse().id_token;
    var googleId = googleUser.getId();

    console.log({googleId});
    console.log({accessToken: id_token});
  }

  render() {
    return (
      <div>
        <h1>About</h1>
        <GoogleLogin
          socialId="746348471088-715be7j4k7ss681trrou2d74tlpdgkhr.apps.googleusercontent.com"
          className="google-login"
          scope="profile"
          fetchBasicProfile={false}
          responseHandler={this.responseGoogle}
          buttonText="Login With Google"/>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/containers/About.js